var _excluded = ["isActive", "text", "icon", "color", "hasDarkMode", "hasFullWidth"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import TextAtm from "../TextAtm";
import { Icon, Link } from "./LinkButtonAtm.styled";
function LinkButtonAtm(linkButton) {
  var isActive = linkButton.isActive,
    text = linkButton.text,
    icon = linkButton.icon,
    color = linkButton.color,
    hasDarkMode = linkButton.hasDarkMode,
    hasFullWidth = linkButton.hasFullWidth,
    link = _objectWithoutProperties(linkButton, _excluded);
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: hasDarkMode ? "backgroundBlack" : "backgroundLight"
  }, /*#__PURE__*/React.createElement(Link, _extends({
    key: text,
    $isActive: isActive,
    $activeColor: color,
    $hasDarkMode: !!hasDarkMode,
    $hasFullWidth: !!hasFullWidth
  }, link), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "large"
  }, /*#__PURE__*/React.createElement(Icon, {
    rightUnit: 10,
    hasNoReset: true,
    $isActive: isActive,
    $hasDarkMode: !!hasDarkMode
  }, icon)), /*#__PURE__*/React.createElement(TextAtm, {
    typography: {
      small: "small2",
      medium: "small2",
      large: "medium2_h"
    }
  }, text)));
}
export default LinkButtonAtm;